import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';

// Plays splash.mp4 full-screen, then fades out and calls onDone().
export default function SplashScreen({ onDone }) {
  const videoRef = useRef(null);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const vid = videoRef.current;
    if (!vid) return;

    function handleEnded() {
      setFading(true);
      setTimeout(onDone, 600); // match fade duration
    }

    vid.addEventListener('ended', handleEnded);

    // Fallback: if video fails or takes too long, skip after 5s
    const fallback = setTimeout(() => {
      setFading(true);
      setTimeout(onDone, 600);
    }, 5000);

    vid.play().catch(() => {
      // Autoplay blocked — skip splash immediately
      onDone();
    });

    return () => {
      vid.removeEventListener('ended', handleEnded);
      clearTimeout(fallback);
    };
  }, [onDone]);

  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        bgcolor: '#0D0D0D',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        opacity: fading ? 0 : 1,
        transition: 'opacity 0.6s ease',
      }}
    >
      <video
        ref={videoRef}
        src="/splash.mp4"
        muted
        playsInline
        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
      />
    </Box>
  );
}
